import moment from "moment";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "service/API";
import { setReportAnalysis } from "store/actionReducers/ReportStore";

const useReport = () => {
  const dispatch = useDispatch();

  const fetchReport = useCallback(async (stock) => {
    const year = moment().add('month', '-3').year()
    // const quarter = moment().add('month', '-3').quarter()
    const quarter = moment().add('month').quarter()
    const res = await API.Report.GetAnalysis({
      ticker: stock,
    })
    if (res?.code === '0') {
      dispatch(setReportAnalysis(res?.data))
    }
  }, [])

  return { fetchReport }
}

export default useReport